import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import AppLayout from '@/Layouts/AppLayout'
import { useTitle } from '@/Utilities/Hooks'
import { Container } from '@/Components/'

export default function General({
  organization,
}) {
  useTitle('Emission Factor Validation Service Terms')

  return (
    <Container size={"4xl:max-w-screen-3xl"} padding={"px-4 lg:px-16 4xl:px-32"} className="4xl:mx-0 relative flex flex-col flex-wrap self-center max-w-5xl p-4 mb-8 overflow-visible md:flex-row xl:dots-topright xl:dots-bottomleft md:p-8 lg:p-16">
      <div className="flex flex-col items-stretch max-w-[44em]">

        <div className="flex flex-row flex-shrink-0 my-4">
          <div className="w-full">
            <h1 className="mb-4 header-1">Emission Factor Validation Service Terms</h1>
            {/* <p className="text-gray-700">Thank you for using Emma. By using Emma, you agree to our Terms and Conditions, which is a legal agreement. If you are using Emma for an organization, you are agreeing on behalf of that organization. Our Terms and Conditions apply to your use of our Websites and Services.</p> */}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="w-full">
            <p className="mb-2 text-gray-700">As an Emma user, depending on your subscription plan, you have the ability to use our emission factor validation service. The purpose with the validation is to review emission factors submitted by the users to assure methodological quality and calculation reliability. These terms are valid between the user and Gidås Sustainability Agency SE559060-447501 (Gidås) concerning the submitted data. To use the validation service, you must accept these terms.</p>
            <p className="mb-2 text-gray-700">Each submission is subject to a non-refundable submission fee of 2 500 SEK plus VAT regardless of scope and complexity of the factor. If considered necessary, Gidås reserves the right to change the submission fee before starting the validation process. Gidås must inform the user and receive a written approval before proceeding if billing is changed. Billing is made for the outstanding billing month in accordance with the general terms and conditions of Emma.</p>
            <p className="mb-2 text-gray-700">The user must be prepared to answer questions and follow up with additional information and/or documentation if Gidås requests it to complete the validation process. Gidås will submit a written reviewal statement and add the Gidås Quality Assurance Seal to the emission factor when granted. Gidås reserves the right to freely publish all granted emission factors via the validation service in our Emma global emission factor database. Gidås reserves the right to change, update and/or remove any emission factor in the global database. </p>
            <p className="mb-2 text-gray-700">Gidås reserves the right to review submitted emission factors ongoing with no time limitations. Gidås has the right not to grant an emission factor the Quality Assurance Seal. If underlying data is improved and the user wish to reopen the validation process, this will be done at no additional charge. Our general terms and conditions apply regarding data, statistics, and General Data Protection Regulation.</p>
            <p className="mb-2 text-gray-700">If you have any questions regarding the Emission factor validation service terms, please contact us by email at emma@gidas.se or please write to the following address:</p>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="w-full">
            <p className="text-gray-700">Gidås Hållbarhetsbyrå AB</p>
            <p className="text-gray-700">Dille 226</p>
            <p className="text-gray-700">836 95 ÅS</p>
            <p className="text-gray-700">SWEDEN</p>
          </div>
        </div>

        <p className="bottom-0 right-0 mt-3 text-typo-inactive md:p-2 md:absolute">Last updated: September 09, 2022</p>
      </div>
    </Container>

  )
}

General.layout = page => (
  <AppLayout>{page}</AppLayout>
)
